import LayerStyles, { COR_CAMADA_IMOVEL } from '../layerStyles';

export const LEGENDA_MAPA_HISTORICO = [
    {
        name: 'mensagens.monitoramento.historico.agricola.areaMonitorada',
        dash: true,
        line: false,
        circle: false,
        color: COR_CAMADA_IMOVEL
    }
];

export const LEGENDA_MAPA_INICIAL = [
    {
        name: 'Algodão',
        dash: false,
        line: false,
        circle: true,
        color: LayerStyles.ALGODAO().color
    },
    {
        name: 'Milho',
        dash: false,
        line: false,
        circle: true,
        color: LayerStyles.MILHO().color
    },
    {
        name: 'Soja',
        dash: false,
        line: false,
        circle: true,
        color: LayerStyles.SOJA().color
    },
    {
        name: 'Outros',
        dash: false,
        line: false,
        circle: true,
        color: LayerStyles.OUTROS().color
    },
    {
        name: 'Não identificado',
        dash: false,
        line: false,
        circle: true,
        color: LayerStyles.NAO_IDENTIFICADA().color
    }
];
